import angular from 'angular';

import designType from './designType';
import version from './version';
import emailsFilter from './emailsFilter';
import buildingUsage from './buildingUsage';
import nrg from './nrg';
import na from './na';
import nrgColor from './nrgColor';
import planType from './planType';

const filtersModule = angular.module('meredicte.filters', [])
  .filter({ designType })
  .filter({ emailsFilter })
  .filter({ buildingUsage })
  .filter({ version })
  .filter({ nrg })
  .filter({ na })
  .filter({ nrgColor })
  .filter({ planType });

export default filtersModule;



// WEBPACK FOOTER //
// ./src/filters/filters.module.js